export const DEFAULT_OG_TYPE = 'spotahome:ad';
export const DEFAULT_OG_SITE_NAME = 'Spotahome';
export const DEFAULT_OG_LOCALE = 'en_US';

const DEFAULT_PROPERTIES = {
  type: DEFAULT_OG_TYPE,
  siteName: DEFAULT_OG_SITE_NAME,
  locale: DEFAULT_OG_LOCALE
};

const PROPERTIES_MAP = {
  type: 'og:type',
  title: 'og:title',
  description: 'og:description',
  url: 'og:url',
  imageUrl: 'og:image',
  siteName: 'og:site_name',
  locale: 'og:locale'
};

export function createOpenGraphMetas(props = {}) {
  const mergedProps = { ...DEFAULT_PROPERTIES, ...props };
  const allowedKeys = Object.keys(PROPERTIES_MAP);

  return allowedKeys
    .filter(key => typeof mergedProps[key] !== 'undefined')
    .reduce(
      (acc, key) => [
        ...acc,
        {
          property: PROPERTIES_MAP[key],
          content: mergedProps[key]
        }
      ],
      []
    );
}

export default {
  createOpenGraphMetas,
  DEFAULT_OG_TYPE,
  DEFAULT_OG_SITE_NAME,
  DEFAULT_OG_LOCALE
};
